import ForgotPasswordSubmitInputForm from './ForgotPasswordSubmitInputForm';

export default ForgotPasswordSubmitInputForm;
